import styled from 'styled-components'
import { colors, media, Typography } from '../../style'
import { StyledSection } from '../../pages/Redemption/Redemption.styles'

export const Section = styled(StyledSection)`
  background: ${colors.PRIMARY_RED_100};
  padding: 24px 0 24px 0;

  img {
    align-self: center;
    max-width: 100%;

    @media ${media.desktopAndHigher} {
      align-self: unset;
      width: unset;
    }
  }
`

export const Title = styled(Typography.H2White)`
  margin-top: 12px;
  margin-bottom: 24px;

  @media ${media.desktopAndHigher} {
    margin-top: 40px;
    margin-bottom: 28px;
  }
`

export const Body = styled(Typography.BodyBoldWhite)`
  p {
    margin-bottom: 12px;
  }
`

export const DesktopVRLogo = styled.img`
  margin-right: auto;
  margin-top: 40px;
`

export const MobileVRLogo = styled.img`
  margin-top: 24px;
`

export const Image = styled.img`
  margin-left: auto;
  margin-right: 34px;
`

export const Button = styled(Typography.Button1White)`
  margin-top: 40px;
  margin-bottom: 16px;

  @media ${media.desktopAndHigher} {
    margin-bottom: 66px;
    width: 267px;
  }
`
